export default "__VITE_ASSET__DgUbdJEb__"